import React from 'react';

import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';

import { Messages } from '../../../codegen/Localize';
import { LogoService } from '../../../settings/general-settings/components/sections/siteLogo/services/LogoService';

export const SignInLogo: React.FunctionComponent = () => {
  const [logo, setLogo] = React.useState(null);
  React.useEffect(() => {
    ServerSettingsUnauthenticated.fetchServerSettingsUnauthenticatedPromise.then(() => {
      // Only when the promise above is resolved, the staticUrlPrefix could be ready for the images when it's in the online environment.
      setLogo(LogoService.getSignInLogo());
    });
  }, []);

  return logo && <img
    src={logo.image}
    title={logo.title}
    alt={Messages.signinLogo()}
    style={{
      maxWidth: logo.width,
      maxHeight: logo.height
    }}
    data-tb-test-id="tableau-server-logo"
  />;
};
